/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProximityZone } from './ProximityZone';
import {
    ProximityZoneFromJSON,
    ProximityZoneFromJSONTyped,
    ProximityZoneToJSON,
    ProximityZoneToJSONTyped,
} from './ProximityZone';
import type { BadgeAntennaBType } from './BadgeAntennaBType';
import {
    BadgeAntennaBTypeFromJSON,
    BadgeAntennaBTypeFromJSONTyped,
    BadgeAntennaBTypeToJSON,
    BadgeAntennaBTypeToJSONTyped,
} from './BadgeAntennaBType';

/**
 * 
 * @export
 * @interface BadgeZoneViolationEventCreate
 */
export interface BadgeZoneViolationEventCreate {
    /**
     * 
     * @type {string}
     * @memberof BadgeZoneViolationEventCreate
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof BadgeZoneViolationEventCreate
     */
    time: Date;
    /**
     * 
     * @type {string}
     * @memberof BadgeZoneViolationEventCreate
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BadgeZoneViolationEventCreate
     */
    vehicleId: string;
    /**
     * 
     * @type {boolean}
     * @memberof BadgeZoneViolationEventCreate
     */
    isMuted: boolean;
    /**
     * 
     * @type {ProximityZone}
     * @memberof BadgeZoneViolationEventCreate
     */
    triggeredZone: ProximityZone;
    /**
     * ELOshield pedestrian badge that triggered the event.
     * @type {number}
     * @memberof BadgeZoneViolationEventCreate
     */
    antennaBNetworkId: number;
    /**
     * 
     * @type {BadgeAntennaBType}
     * @memberof BadgeZoneViolationEventCreate
     */
    badgeAntennaBType: BadgeAntennaBType;
    /**
     * 
     * @type {number}
     * @memberof BadgeZoneViolationEventCreate
     */
    minimumDistanceCm?: number | null;
}



/**
 * Check if a given object implements the BadgeZoneViolationEventCreate interface.
 */
export function instanceOfBadgeZoneViolationEventCreate(value: object): value is BadgeZoneViolationEventCreate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('isMuted' in value) || value['isMuted'] === undefined) return false;
    if (!('triggeredZone' in value) || value['triggeredZone'] === undefined) return false;
    if (!('antennaBNetworkId' in value) || value['antennaBNetworkId'] === undefined) return false;
    if (!('badgeAntennaBType' in value) || value['badgeAntennaBType'] === undefined) return false;
    return true;
}

export function BadgeZoneViolationEventCreateFromJSON(json: any): BadgeZoneViolationEventCreate {
    return BadgeZoneViolationEventCreateFromJSONTyped(json, false);
}

export function BadgeZoneViolationEventCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): BadgeZoneViolationEventCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'time': (new Date(json['time'])),
        'userId': json['userId'] == null ? undefined : json['userId'],
        'vehicleId': json['vehicleId'],
        'isMuted': json['isMuted'],
        'triggeredZone': ProximityZoneFromJSON(json['triggeredZone']),
        'antennaBNetworkId': json['antennaBNetworkId'],
        'badgeAntennaBType': BadgeAntennaBTypeFromJSON(json['badgeAntennaBType']),
        'minimumDistanceCm': json['minimumDistanceCm'] == null ? undefined : json['minimumDistanceCm'],
    };
}

export function BadgeZoneViolationEventCreateToJSON(json: any): BadgeZoneViolationEventCreate {
    return BadgeZoneViolationEventCreateToJSONTyped(json, false);
}

export function BadgeZoneViolationEventCreateToJSONTyped(value?: BadgeZoneViolationEventCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'time': value['time'].toISOString(),
        'userId': value['userId'],
        'vehicleId': value['vehicleId'],
        'isMuted': value['isMuted'],
        'triggeredZone': ProximityZoneToJSON(value['triggeredZone']),
        'antennaBNetworkId': value['antennaBNetworkId'],
        'badgeAntennaBType': BadgeAntennaBTypeToJSON(value['badgeAntennaBType']),
        'minimumDistanceCm': value['minimumDistanceCm'],
    };
}

